export type OrganizationUseCase = "School" | "SLP";

export type UseCaseTerminology = {
  useCase: OrganizationUseCase;
  directory: string;
  class: string;
  classes: string;
  managedUser: string;
  managedUsers: string;
  teacher: string;
  teachers: string;
  student: string;
  students: string;
};

export const getOrganizationUseCase = (): OrganizationUseCase => {
  try {
    const currentUser = JSON.parse(sessionStorage.getItem("current_user") || "{}");
    return currentUser.organization_use_case === "SLP" ? "SLP" : "School";
  } catch {
    return "School";
  }
};

export const getUseCaseTerminology = (): UseCaseTerminology => {
  const useCase = getOrganizationUseCase();

  if (useCase === "SLP") {
    return {
      useCase,
      directory: "Directory",
      class: "Caseload",
      classes: "Caseloads",
      managedUser: "User",
      managedUsers: "Users",
      teacher: "Clinician",
      teachers: "Clinicians",
      student: "Client",
      students: "Clients",
    };
  }

  return {
    useCase,
    directory: "Directory",
    class: "Class",
    classes: "Classes",
    managedUser: "User",
    managedUsers: "Users",
    teacher: "Teacher",
    teachers: "Teachers",
    student: "Student",
    students: "Students",
  };
};
